import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { SuccessPopupComponent } from './components/success-popup/success-popup.component';
import { MaterialModule } from 'src/app/material/material.module';
import { ThankYouComponent } from './components/thank-you/thank-you.component';
import { AdminPortalComponent } from './components/admin-portal/admin-portal.component';
import { AddItemsModelComponent } from './components/add-items-model/add-items-model.component';
import { AlphabeticDirective } from './directive/alphabetic.directive';
import { NgxMaskModule } from 'ngx-mask';
import { ShortNamePipe } from './pipe/short-name.pipe';
import { ListingComponent } from './components/listing/listing.component';
import { MappingPipe } from './pipe/mapping.pipe';
import { RouterModule } from '@angular/router';
import { PercentageDirective } from './directive/percentage/percentage.directive';
import { AlertDialogComponent } from './components/alert-dialog/alert-dialog.component';
import { RadioFocusDirective } from './directive/radio-focus.directive';
import { OnlyIntegerDirective } from './directive/onlyNumber/only-integer.directive';
import { CustomPrintDirective } from './directive/custom-print.directive';
import { PrintMiscVoucherComponent } from './components/print-misc-voucher/print-misc-voucher.component';
import { ChipsAutocompleteComponent } from './components/chips-autocomplete/chips-autocomplete.component';




@NgModule({
  declarations: [
    ConfirmDialogComponent,
    SuccessPopupComponent,
    ThankYouComponent,
    AdminPortalComponent,
    AddItemsModelComponent,
    AlphabeticDirective,
    ShortNamePipe,
    ListingComponent,
    MappingPipe,
    PercentageDirective,
    AlertDialogComponent,
    RadioFocusDirective,
    OnlyIntegerDirective,
    CustomPrintDirective,
    ChipsAutocompleteComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    NgxMaskModule.forRoot(),
    RouterModule
  ],
  exports:[AlphabeticDirective, NgxMaskModule, ShortNamePipe,ListingComponent, OnlyIntegerDirective, ChipsAutocompleteComponent]
})
export class SharedModule { }
